import { MainRoute } from "./AllRoutes";
import "./App.css";

function App() {
	return (
		<div className="App">
			<MainRoute />
		</div>
	);
}

export default App;
